import { Button, Modal } from "antd";
import React, { useEffect, useRef, useState } from "react";
import WebUtils from "../../utils/WebUtils";
import {
  updateAudioAnomalyApi,
  updateConversationHistoryApi,
} from "../../../api";
import Icon from "../../../assets/Icon";
import ReactTypingEffect from "react-typing-effect";

function InterviewRejoinModal({
  rejoinModal,
  interviewData,
  conversationHistory,
  setLoading,
  videoBlobQueueRef,
  screenShareBlobQueueRef,
  timeRemainingRef,
  chatMessagesRef,
  stopRecording,
}) {
  const elapsedSecondsRef = useRef(0);
  const updateApiFlag = useRef(false);
  const anomalyApiFlag = useRef(false);
  const endIntervalRef = useRef(null);

  const endInterviewFunc = () => {
    // setLoading(true);
    elapsedSecondsRef.current += 1;
    // console.log(
    //   updateApiFlag.current,
    //   anomalyApiFlag.current,
    //   elapsedSecondsRef.current
    // );
    if (
      elapsedSecondsRef.current >= 10 &&
      videoBlobQueueRef.current.length === 0 &&
      screenShareBlobQueueRef.current.length === 0 &&
      updateApiFlag.current &&
      anomalyApiFlag.current
    ) {
      // setLoading(false);
      clearInterval(endIntervalRef.current);
      window.location.href = `/preview?interviewId=${interviewData?.interviewId}`;
      return;
    }
  };

  const updateConverstionHistory = () => {
    const url = updateConversationHistoryApi;

    const requestBody = {
      interviewId: interviewData?.interviewId,
      interviewRemainingTime: timeRemainingRef.current,
      conversation: chatMessagesRef.current,
    };

    WebUtils.httpOperations(url, requestBody, "POST")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        updateApiFlag.current = true;
      });
  };

  const callDeviceAnomalyApi = () => {
    const url =
      updateAudioAnomalyApi + `?interviewId=${interviewData?.interviewId}`;

    let stamp =
      conversationHistory?.interviewDuration - timeRemainingRef.current;

    const requestBody = {
      timestamp: stamp,
      audioAnomalyType: "Device Change Detected",
    };

    WebUtils.httpOperations(url, requestBody, "POST")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        anomalyApiFlag.current = true;
      });
  };

  useEffect(() => {
    callDeviceAnomalyApi();
    updateConverstionHistory();
    setTimeout(() => {
      stopRecording();
      endIntervalRef.current = setInterval(endInterviewFunc, 500);
    }, 1200);

    return () => {
      clearInterval(endIntervalRef.current);
    };
  }, []);
  return (
    <Modal
      className="rejoin-modal"
      open={rejoinModal}
      // onCancel={() => {
      //   updateConverstionHistory();
      //   endIntervalRef.current = setInterval(endInterviewFunc, 500);
      // }}
      centered
      footer={null}
      closeIcon={null}
      width={455}
    >
      <div className="">
        <Icon type="warning-icon" width="45" height="45" />
      </div>
      <div className="mt-[.55rem] font-semibold text-[1.05rem] text-[#101828]">
        Device Change Detected
      </div>
      <p className="mt-[.55rem] text-[0.88rem] text-[#475467] leading-[1.38rem]">
        Device change detected. This is a proctored environment. To ensure
        integrity, we will store the interview state and redirect you to re-join
        the interview.
      </p>
      <div className="mt-[.55rem] mb-[.35rem] text-[.88rem] text-[#206DC5] font-medium flex gap-1">
        Please wait,
        <ReactTypingEffect
          text={[
            "we are storing your conversation...",
            "we are saving your interview state...",
            "we are saving your interview duration...",
            "we are uploading your video recordings...",
            "we are uploading your screen recordings...",
          ]}
          speed={50} // Typing speed
          eraseSpeed={30} // Erase speed
          eraseDelay={1000} // Delay before erasing
          typingDelay={500} // Delay before typing starts
          loop={true} // Infinite loop
        />
      </div>
    </Modal>
  );
}

export default InterviewRejoinModal;
